// tslint:disable
export var Extauth2ChangePasswordStatus;
(function (Extauth2ChangePasswordStatus) {
    // change password was successful
    Extauth2ChangePasswordStatus[Extauth2ChangePasswordStatus["Success"] = 0] = "Success";
    // change password failed
    Extauth2ChangePasswordStatus[Extauth2ChangePasswordStatus["Failed"] = 1] = "Failed";
    // change password invalid user
    Extauth2ChangePasswordStatus[Extauth2ChangePasswordStatus["InvalidUser"] = 1] = "InvalidUser";
    // change password account locked
    Extauth2ChangePasswordStatus[Extauth2ChangePasswordStatus["AccountLocked"] = 1] = "AccountLocked";
})(Extauth2ChangePasswordStatus || (Extauth2ChangePasswordStatus = {}));
Extauth2ChangePasswordStatus['SUCCESS'] = 0;
Extauth2ChangePasswordStatus['FAILED'] = 1;
Extauth2ChangePasswordStatus['INVALIDUSER'] = 1;
Extauth2ChangePasswordStatus['ACCOUNTLOCKED'] = 1;
//# sourceMappingURL=Extauth2ChangePasswordStatus.js.map